import { Update } from 'history';
import { ReactElement, useState, useLayoutEffect, ReactNode } from 'react';
import { Router as RouterBase } from 'react-router';

import sharedHistory from '../sharedHistory';

export interface IRouterProps {
  children: ReactNode;
}

const Router = ({ children }: IRouterProps): ReactElement => {
  const [state, setState] = useState<Update>(sharedHistory);

  useLayoutEffect(
    (): (() => void) => sharedHistory.listen(setState),
    [],
  );

  // NOTE (react-router v7): the spread `state` is a history `Update`
  // (`{ action, location }`). The low-level `Router` reads `location` and
  // `navigationType` (NOT `action`), so `action` is harmlessly ignored and
  // `navigationType` defaults to "POP" — identical behavior to react-router v6.
  // Do not "fix" this into passing `navigationType`; it would be a no-op change.
  return (
    <RouterBase
      children={children}
      navigator={sharedHistory}
      {...state}
    />
  );
};

export default Router;
